import { models } from './models';

export const normalize = (entityArray) => {
  // TODO Throw error if entityArray is not array
  const schema = { items: {}, list: [] };

  const normalized = entityArray.reduce((normalizedObject, item) => {
    const newNormalizedObject = normalizedObject;
    const newItem = models.questions(item);

    newNormalizedObject.list.push(item.id);
    newNormalizedObject.items[item.id] = newItem;

    return newNormalizedObject;
  }, schema);

  return normalized;
};

// No modeliza de nuevo con el modelo anterior porque reciben campos diferentes (newItem)
// Solo añade los items
export const normalize2 = (entityArray) => {
  // TODO Throw error if entityArray is not array
  const schema = { items: {}, list: [] };

  const normalized = entityArray.reduce((normalizedObject, item) => {
    const newNormalizedObject = normalizedObject;

    newNormalizedObject.list.push(item.id);
    newNormalizedObject.items[item.id] = item;

    return newNormalizedObject;
  }, schema);

  return normalized;
};

export const normalizeNO = (entityArray) => {
  // TODO Throw error if entityArray is not array
  const schema = {};

  const normalized = entityArray.reduce((normalizedObject, item) => {
    const newNormalizedObject = normalizedObject;

    newNormalizedObject[item.id] = models.tags(item);

    return newNormalizedObject;
  }, schema);

  return normalized;
};
